import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import { RoleTypeStrategy } from '../../../../global/strategies/user_mode_api_strategy';
import { APProgramSlot } from '../../../builders/ap_program_slot_builder';
import { IAPPlannedCourseDataSource } from '../../../datasources/ap_planned_course_datasource';
import { IAPProgramSlotDatasource } from '../../../datasources/ap_program_slot_datasource';
import { APCommandUrlServant } from '../../../servants/ap_command_url_servant';
import { APProgramSlotServant } from '../../../servants/ap_program_slot_servant';

export interface ICourseGroup {
  id: number;
  program_slot: number;
}

angular.module('capability-ng-academic-planner').factory(
  'removeCourseFromTermAndAddCourseGroupCommand',
  /* tslint:disable:parameters-max-number */
  (
    log: any,
    $http: ng.IHttpService,
    $rootScope: ng.IRootScopeService,
    $state: ng.ui.IStateService,
    ngAPPlannedCoursesDatasource: IAPPlannedCourseDataSource,
    ngAPCommandUrlServant: APCommandUrlServant,
    advisorSaveCourseGroupToTermCommand: ICommand,
    studentSaveCourseGroupToTermCommand: ICommand,
    ngAPProgramSlotDatasource: IAPProgramSlotDatasource,
    defineCommandORM: IDefineCommand
  ): ICommand => {
    return defineCommandORM(
      'removeCourseFromTermAndAddCourseGroupCommand',
      (deferred: ng.IDeferred<IQuery[]>, courseToRemove: any, term: number, programSlot: APProgramSlot): void => {
        const payload = {
          course_id: courseToRemove.course,
          term_id: term
        };

        $rootScope.$emit('my.planner.show.saving.message', term);

        const roleType = RoleTypeStrategy.evaluate($state);
        const academicPlanUrl = ngAPCommandUrlServant.get('academicPlan');

        $http
          .delete(academicPlanUrl, {
            data: payload
          })
          .then(() => {
            ngAPPlannedCoursesDatasource.del(courseToRemove.id as number);
            const pgmSlot = ngAPProgramSlotDatasource.get(courseToRemove.program_slot);
            if (pgmSlot && APProgramSlotServant.isWildcardProgramSlot(pgmSlot)) {
              pgmSlot.is_course_planned = false;
              ngAPProgramSlotDatasource.put(pgmSlot);
            }
            if (roleType === 'student') {
              studentSaveCourseGroupToTermCommand(term, programSlot, programSlot.id).then(deferred.resolve);
            } else if (roleType === 'advisor') {
              advisorSaveCourseGroupToTermCommand(term, {
                program_slot: programSlot.id,
                course_group: programSlot.course_group
              }).then(deferred.resolve);
            }
          })
          .catch((e: any) => {
            log.issue('failed to remove course');
            deferred.reject(e);
          });
      }
    );
  }
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_group_button/commands/remove_course_from_term_and_add_course_group_command.ts